import { Route } from '@angular/router';

/** Master / reference data (parties, items, accounts, stock structure). */
export const mastersChildren: Route[] = [
  {
    path: 'customers',
    loadChildren: () =>
      import('app/modules/masters/customers/customers.module').then((m) => m.CustomersModule),
    data: { permission: 'masters.customers' },
  },
  {
    path: 'supplier',
    loadChildren: () =>
      import('app/modules/masters/supplier/supplier.module').then((m) => m.SupplierModule),
    data: { permission: 'masters.suppliers' },
  },
  {
    path: 'company',
    loadChildren: () =>
      import('app/modules/masters/companies/companies.module').then((m) => m.CompaniesModule),
    data: { permission: 'masters.company' },
  },
  {
    path: 'generics',
    loadChildren: () => import('app/modules/masters/generic/generic.module').then((m) => m.GenericModule),
    data: { permission: 'masters.generics' },
  },
  {
    path: 'hsn-code',
    loadChildren: () => import('app/modules/masters/hsn-code/hsn.module').then((m) => m.HsnModule),
    data: { permission: 'masters.others.hsnCodeMaster' },
  },
  {
    path: 'item',
    loadChildren: () => import('app/modules/masters/item/item.module').then((m) => m.ItemModule),
    data: { permission: 'masters.items' },
  },
  {
    path: 'category',
    loadChildren: () =>
      import('app/modules/masters/categories/categories.module').then((m) => m.CategoryModule),
    data: { permission: 'masters.category' },
  },
  {
    path: 'ledger',
    loadChildren: () => import('app/modules/masters/ledger/ledger.module').then((m) => m.LedgerModule),
    data: { permission: 'masters.ledgerMaster' },
  },
  {
    path: 'account-group',
    loadChildren: () =>
      import('app/modules/masters/account-group/account-groups.module').then((m) => m.AccountGroupModule),
    data: { permission: 'masters.accountGroup' },
  },
  {
    path: 'batch',
    loadChildren: () => import('app/modules/masters/batch/batch.module').then((m) => m.BatchModule),
    data: { permission: 'masters.batch' },
  },
  {
    path: 'doctor',
    loadChildren: () => import('app/modules/masters/doctor/doctor.module').then((m) => m.DoctorModule),
    data: { permission: 'masters.doctors' },
  },
  {
    path: 'therapeutic-category',
    loadChildren: () =>
      import('app/modules/masters/therapeutic-category/therapeutic-category.module').then(
        (m) => m.TherapeuticCategoryModule,
      ),
    data: { permission: 'masters.therapeuticCategory' },
  },
  {
    path: 'item-ledger',
    loadChildren: () =>
      import('app/modules/masters/inventory/inventory.module').then((m) => m.InventoryModule),
  },
  {
    path: 'company-group',
    loadChildren: () =>
      import('app/modules/masters/company-group/company-group.module').then((m) => m.CompanyGroupModule),
  },
  {
    path: 'ledger-group',
    loadChildren: () =>
      import('app/modules/masters/ledger-group-master/ledger-group.module').then(
        (m) => m.LedgerGroupModule,
      ),
  },
  {
    path: 'banks',
    loadChildren: () => import('app/modules/masters/bank/bank.module').then((m) => m.BankModule),
  },
  {
    path: 'schedule',
    loadChildren: () =>
      import('app/modules/masters/schedule-master/schedule.module').then((m) => m.ScheduleModule),
  },
  {
    path: 'cheques',
    loadChildren: () => import('app/modules/masters/cheques/cheques.module').then((m) => m.ChequesModule),
  },
  {
    path: 'storage-rack',
    loadChildren: () =>
      import('app/modules/masters/storage-rack/storage-rack.module').then((m) => m.StorageRackModule),
    data: { permission: 'masters.others.storageRack' },
  },
  {
    path: 'vendor-pricing',
    loadChildren: () =>
      import('app/modules/masters/vendor-pricing/vendor-pricing.routes').then((m) => m.vendorPricingRoutes),
  },
];
